<template>
    <div>
        <breadcrumbs
                :title="'Računi za uplate'"
                :breadcrumbs="breadcrumbs"
        >
        </breadcrumbs>
        <div class="ibox ">
            <div class="ibox-title">
                    <h5>Računi za uplate</h5><br>
                <button
                        type="button"
                        class="btn btn-lg btn-primary"
                        @click="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                        v-if="show_datatable"
                        :url="datatables_url"
                        :settings="datatables.settings"
                        :title="datatables.title"
                        @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>

</template>

<script>
import Datatables from "@/components/datatable/Datatables";
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
export default {
name: "RacuniZaUplate",
    components: {Breadcrumbs, Datatables},
    data(){
        return{
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL + 'racun-za-uplatu',
            datatables: {},
            breadcrumbs: [],
        }
    },
    methods:{
        rowClick( row ){
            this.$router.push( { path: '/postavke/racuni-za-uplate/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/postavke/racuni-za-uplate/create' } )
        },

        setDatatable(){
            let vm = this
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'primatelj',
                            'title': 'Naziv',
                            'column_visibility_group':{
                                id: 'recuni'
                            }
                        },
                        {
                            'id': 'oib',
                            'title': 'OIB',
                            'column_visibility_group':{
                                id: 'recuni'
                            }
                        },
                        {
                            'id': 'broj_racuna',
                            'title': 'Broj računa',
                            'column_visibility_group':{
                                id: 'recuni'
                            }
                        },
                        {
                            'id': 'adresa',
                            'title': 'Adresa',
                            'column_visibility_group':{
                                id: 'recuni'
                            }
                        },
                        {
                            'id': 'mjesto',
                            'title': 'Mjesto',
                            'column_visibility_group':{
                                id: 'recuni'
                            }
                        },
                        {
                            'id': 'postanski_broj',
                            'title': 'Poštanski broj',
                            'column_visibility_group':{
                                id: 'recuni'
                            }
                        }
                    ],
                            column_visibility_groups:{
                        'recuni': 'Računi'
                    },
                    order: 'desc',
                            order_by: 'id'
                },
                title: 'Računi za uplate'
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/racuni_za_uplate',
                    name: 'Računi za uplate'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>